// extracted by mini-css-extract-plugin
module.exports = {"uploadContainer":"styles_uploadContainer__h60O5","uploadcard":"styles_uploadcard__2kQ0c","downloadBtn":"styles_downloadBtn__1Zi8z"};